import React from 'react'
import { connect } from 'react-redux'
import { Row, Col, Label } from 'reactstrap'
import LoadingIndicator from '@/components/LoadingIndicator'
import { LanguageSelector } from './languageSelector'
import { actionCreators } from '@/store/languageSettings'
import Resx from '@/components/Resx'
import { WhiteBox } from '@/components/Layout'

class LanguageSettings extends React.Component {
  componentDidMount () {
    this.props.get()
  }
  handleUpdate = (language) => {
    this.props.update(language)
  }
  render () {
    const { languageSettings } = this.props
    const { fetching } = languageSettings
    return (
      <WhiteBox
        className=''
        header='UserProfile.LanguageSettings'>
        <Row>
          <Col><Label><Resx name='UserProfile.ChooseYourPreferredLanguage' /></Label></Col>
        </Row>
        {fetching && <LoadingIndicator />}
        {!fetching && <LanguageSelector key={languageSettings.componentKey} languageSettings={languageSettings} update={this.handleUpdate} />}
      </WhiteBox>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  languageSettings: state.languageSettings,
  ...ownProps
})

const mapDispatchToProps = {
  get: actionCreators.get,
  update: actionCreators.update
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSettings)



// WEBPACK FOOTER //
// ./src/components/userProfile/languageSettings/index.js